import React, { useRef, useState } from 'react';
import OffersSectionRow from '../../components/OffersSectionRow';
import { useIdHash, useNavigateRoute } from '../../hooks/custom.hooks';
import AppLayout from '../../layout/AppLayout';
import styles from './index.module.scss';
import useOffers from '../../hooks/useOffers';
import TopBrandRow from '../../components/TopBrandRow';
import CategoryRow from '../../components/CategoryRow';
import Footer from '../../components/Footer';
import OffersAndBrandSection from '../../components/OffersAndBrandSection';
import offerIntro from '../../assets/videos/offerIntro.mp4';
import replayVid from '../../assets/global/replay-vid.png';
import FadeInSection from '../../wrapper/FadeInWrapper';

function HomePage() {
  const { isApp } = useIdHash();

  const {
    discountOffers,
    exclusiveOffers,
    recommendedOffers,
    offlineOffers,
    topOffers,
  } = useOffers();
  const navigateRoute = useNavigateRoute();

  // /offers/?offer_type=instant&cid=&customer-hash=&app=0
  const discountOffersUrl = `/offers?offer_type=instant`;
  const exclusiveOffersUrl = `/offers?offer_filter_type=exclusive`;
  const recommendedOffersUrl = `/offers?offer_type=recommended`;
  const guranteedSavingsOffersUrl = `/offers?offer_type=guaranteed`;
  const offlineOffersUrl = `/offers?type=offline`;
  const topOffersUrl = '/offers';

  const videoRef = useRef(null);

  const playAgain = () => {
    if (videoRef.current) {
      videoRef.current?.play().catch((error) => {
        console.error('Play error:', error);
      });
      setVideoEnded(false);
    }
  };

  const [videoEnded, setVideoEnded] = useState(false);

  return (
    <AppLayout
      showLogo={!isApp}
      hideBack={!isApp}
      gobackAction={() => {
        navigateRoute({ goBack: true });
      }}
    >
      <div className={styles.homepageWrapper}>
        {!isApp ? (
          <div className={styles.videoIntro}>
            <video
              autoPlay
              muted
              playsInline
              ref={videoRef}
              onEnded={() => setVideoEnded(true)}
            >
              <source src={offerIntro} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            {videoEnded ? (
              <div className={styles.playAgain} onClick={() => playAgain()}>
                <img src={replayVid} alt="play" />
              </div>
            ) : null}
          </div>
        ) : null}
        <FadeInSection>
          {isApp ? <CategoryRow /> : <TopBrandRow />}
        </FadeInSection>
        {isApp ? (
          <OffersSectionRow
            sectionName="Recommended for you"
            cardsData={recommendedOffers}
            showClaim={false}
            onClaim={() => {}}
            onClickViewAll={() =>
              navigateRoute({ nextPage: recommendedOffersUrl })
            }
          />
        ) : null}

        <OffersSectionRow
          sectionName={'TOP OFFERS'}
          cardsData={topOffers}
          showClaim={false}
          onClaim={() => {}}
          onClickViewAll={() => navigateRoute({ nextPage: topOffersUrl })}
        />
        <OffersSectionRow
          sectionName={isApp ? 'Guaranteed Savings' : 'DISCOUNT OFFERS'}
          cardsData={discountOffers}
          showClaim={false}
          onClaim={() => {}}
          onClickViewAll={() =>
            navigateRoute({
              nextPage: isApp ? guranteedSavingsOffersUrl : discountOffersUrl,
            })
          }
        />
        {isApp ? (
          <OffersSectionRow
            sectionName={'Offline offers'}
            cardsData={offlineOffers}
            showClaim={false}
            onClaim={() => {}}
            onClickViewAll={() => navigateRoute({ nextPage: offlineOffersUrl })}
          />
        ) : null}
        {isApp ? (
          <OffersSectionRow
            sectionName="Exclusively for You"
            cardsData={exclusiveOffers}
            showClaim={false}
            onClaim={() => {}}
            sectionNameStyles={{
              fontWeight: 600,
            }}
            onClickViewAll={() =>
              navigateRoute({ nextPage: exclusiveOffersUrl })
            }
          />
        ) : null}
        <OffersAndBrandSection />
        <Footer />
      </div>
    </AppLayout>
  );
}

export default HomePage;
